module.exports = __webpack_public_path__ + "img/home-seven.2c7ef86b.svg";